export const generateToastCss = (cfg: any, mode: 'light' | 'dark') => {
   const isDark = mode === 'dark';

   const bg = isDark ? cfg.background.dark.surface : cfg.background.light.surface;

   const text = isDark ? cfg.text.dark.primary : cfg.text.light.primary;

   return `
  :root {
    --toastify-color-light: ${cfg.background.light.surface};
    --toastify-color-dark: ${cfg.background.dark.surface};
  
    --toastify-color-info: ${cfg.status.info};
    --toastify-color-success: ${cfg.status.success};
    --toastify-color-warning: ${cfg.status.warning};
    --toastify-color-error: ${cfg.status.error};
  
    --toastify-icon-color-info: var(--toastify-color-info);
    --toastify-icon-color-success: var(--toastify-color-success);
    --toastify-icon-color-warning: var(--toastify-color-warning);
    --toastify-icon-color-error: var(--toastify-color-error);
  
    --toastify-text-color-info: ${text};
    --toastify-text-color-success: ${text};
    --toastify-text-color-warning: ${text};
    --toastify-text-color-error: ${text};
  
    --toastify-spinner-color: ${cfg.text.light.secondary};
    --toastify-spinner-color-empty-area: ${cfg.text.light.primary};
  
    --toastify-color-progress-light: linear-gradient(
      to right,
      ${cfg.brand.primary},
      ${cfg.brand.secondary}
    );
  
    --toastify-color-progress-dark: ${cfg.brand.primary};
    --toastify-color-progress-info: var(--toastify-color-info);
    --toastify-color-progress-success: var(--toastify-color-success);
    --toastify-color-progress-warning: var(--toastify-color-warning);
    --toastify-color-progress-error: var(--toastify-color-error);
  
    --toastify-color-progress-bgo: 0.25;
  }
  `;
};
